import videoPreview from './videoPreview.vue';
import audioPreview from './audioPreview.vue';
import imagePreview from './imagePreview.vue';
import pdfPreview from './pdfPreview.vue';
import markdownPreview from './markdownPreview.vue';
import officePreview from './officePreview.vue';
import txtPreview from './txtPreview.vue';
import unknowPreview from './unknowPreview.vue';
const preview = {
  install,
  videoPreview,
  audioPreview,
  imagePreview,
  pdfPreview,
  markdownPreview,
  officePreview,
  txtPreview,
  unknowPreview
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

export default preview

function install(Vue){
  if(install.installed){
    return
  }
  Vue.component(videoPreview.name, videoPreview);
  Vue.component(audioPreview.name, audioPreview);
  Vue.component(imagePreview.name, imagePreview);
  Vue.component(pdfPreview.name, pdfPreview);
  Vue.component(markdownPreview.name, markdownPreview);
  Vue.component(officePreview.name, officePreview);
  Vue.component(txtPreview.name, txtPreview);
  Vue.component(unknowPreview.name, unknowPreview);
}